document.addEventListener('DOMContentLoaded', () => {
  const sort = document.querySelector('.aa-shop-all__sort');
  if (!sort) return;

  const details = sort.querySelector('details');
  if (!details) return;

  // The sort toggle sits close enough to the top of the page that scrolling
  // can carry it behind the sticky header while its panel is still open —
  // the panel (position:absolute, relative to the toggle) keeps rendering
  // at the toggle's now hidden/covered position instead of tracking
  // anything the user can actually see, looking like a disconnected floating
  // menu. Closing on scroll is the standard fix for this class of bug.
  window.addEventListener(
    'scroll',
    () => {
      if (details.open) sort.close();
    },
    { passive: true }
  );
});
